// extracted by mini-css-extract-plugin
module.exports = {"cell":"Minesweeper_cell__39yir","revealed":"Minesweeper_revealed__2sxUU","flag":"Minesweeper_flag__21XEM","mine":"Minesweeper_mine__1CWuF"};